'use client';

import './index.css';

import { Cross2Icon } from '@radix-ui/react-icons';
import { Dialog } from 'radix-ui';
import { useState } from 'react';

import { AutoForm } from '@/components/auto-form';

export const FormDialog = ({ title, form, children }) => {
  const [open, setOpen] = useState(false);

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger asChild>{children}</Dialog.Trigger>

      <Dialog.Portal>
        <Dialog.Overlay className="form-dialog__overlay" />

        <Dialog.Content
          className="form-dialog__content"
          aria-describedby={undefined}
        >
          <div className="form-dialog__header">
            <Dialog.Title className="form-dialog__title">{title}</Dialog.Title>

            <Dialog.Close asChild>
              <button className="form-dialog__icon-button" aria-label="Close">
                <Cross2Icon />
              </button>
            </Dialog.Close>
          </div>

          <AutoForm form={form} onSuccess={() => setOpen(false)} />
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
